import { useI18n } from '../../../hooks/useI18nFormatters';
import { useFlowCardTrigger } from '../../../store/flow-cards/useFlowCardTriggers';
import { NodeArgumentsContext } from '../view-advanced-flow/card/NodeArgumentsContext';

import { FlowCard } from './FlowCard';
import { FlowCardTriggerContextMenuContent } from './FlowCardTriggerContextMenuContent';
import { AddCardButton, flowCardTypes } from './flowCardTypes';
import { flowEditor } from './useFlowEditor';

export function FlowCardTrigger(props) {
  const { i18n } = useI18n();
  const triggerData = props.trigger;
  const { flowCardTrigger } = useFlowCardTrigger({ flowCardTriggerId: triggerData?.id });

  return (
    <NodeArgumentsContext>
      <flowCardTypes.Section>
        <flowCardTypes.Title isNonActive={!triggerData}>
          {`${i18n.messageFormatter('flow.when')}...`}
        </flowCardTypes.Title>

        {triggerData && (
          <flowCardTypes.Content>
            <FlowCard
              key={triggerData.id}
              cardType="trigger"
              cardIndex={0}
              card={flowCardTrigger}
              data={triggerData}
              contextMenuContent={
                <FlowCardTriggerContextMenuContent
                  card={flowCardTrigger}
                  data={triggerData}
                  onReplaceRequest={() => {
                    props.setFlowCardPickerState({
                      type: 'trigger',
                      cardIndex: 0,
                      currentCard: flowCardTrigger,
                    });
                  }}
                  onDeleteRequest={() => {
                    flowEditor.deleteTriggerCard({
                      cardIndex: 0,
                    });
                  }}
                />
              }
            />
          </flowCardTypes.Content>
        )}

        {triggerData == null && (
          <AddCardButton
            onClick={() => {
              props.setFlowCardPickerState({
                type: 'trigger',
              });
            }}
          >
            {i18n.messageFormatter('flow.addCard')}
          </AddCardButton>
        )}
      </flowCardTypes.Section>
    </NodeArgumentsContext>
  );
}
